import axios from 'axios';
import {BehaviorSubject} from 'rxjs';
import {API_URL} from './client';

const accessToken = new BehaviorSubject('');
const refreshToken = new BehaviorSubject('');
const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const USER_EMAIL = 'userEmail';
const USER_PASS = 'userPassword';

const login = (email: string, password: string) => {
  return axios
      .post(`${API_URL}/login/`, {
        'email': email,
        'password': password,
      })
      .then((res) => {
        accessToken.next(res.data.access);
        refreshToken.next(res.data.refresh);
        localStorage.setItem(ACCESS_TOKEN_KEY, res.data.access);
        localStorage.setItem(REFRESH_TOKEN_KEY, res.data.refresh);
        localStorage.setItem(USER_EMAIL, email);
        localStorage.setItem(USER_PASS, password);
      });
};

const logout = () => {
  accessToken.next('');
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

const setRefreshTokenFromLocalStorage = () => {
  const tokenFromLocalStorage = localStorage.getItem(REFRESH_TOKEN_KEY);
  if (tokenFromLocalStorage) {
    setRefreshToken(tokenFromLocalStorage);
  }
};

const setAccessTokenFromLocalStorage = () => {
  const tokenFromLocalStorage = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (tokenFromLocalStorage) {
    setAccessToken(tokenFromLocalStorage);
  }
};

const getAccessTokenFromLocalStorage = () => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

const getUserEmailFromLocalStorage = () => {
  return localStorage.getItem(USER_EMAIL);
};

const getUserPasswordFromLocalStorage = () => {
  return localStorage.getItem(USER_PASS);
};

const setAccessToken = (token: any) => {
  accessToken.next(token);
};

const setRefreshToken = (token: any) => {
  refreshToken.next(token);
};

const refreshAccessToken = () => {
  const data = {refresh: refreshToken.value};
  return axios
      .post(`${API_URL}/token/refresh/`, data)
      .then((res) => {
        setAccessToken(res.data.access);
        setRefreshToken(res.data.refresh);
        localStorage.setItem(ACCESS_TOKEN_KEY, res.data.access);
        localStorage.setItem(REFRESH_TOKEN_KEY, res.data.refresh);
      })
      .catch((res) => {
        if (res.response.status === 401) {
          setAccessToken('');
          setRefreshToken('');
        }
      });
};

export const authService = {
  login,
  logout,
  refreshAccessToken,
  setAccessTokenFromLocalStorage,
  setRefreshTokenFromLocalStorage,
  getUserEmailFromLocalStorage,
  getUserPasswordFromLocalStorage,
  currentToken: accessToken.asObservable(),
  get tokenValue() {
    return getAccessTokenFromLocalStorage();
  },
};
